import { IEntity } from "./id-name";
import { IRequestParams } from "./page";

export interface IIAMEntity extends IEntity<string> {
  Path?: string;
  Arn?: string;
  CreateDate?: string;
}

export function mapEntityId<T extends IIAMEntity>(u: T, key: keyof T): T {
  return {
    ...u,
    id: u[key] as string,
  };
}

export interface IIAMEntityRequestParams<TSortField>
  extends IRequestParams<TSortField> {
  marker?: string;
}

export enum IAMEntityType{
  Credential = "Access Credential",
  Group = "Group",
  Policy = "Policy",
  Role = "Role",
  User = "User",
}